/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectDefinitionColumn } from '../model/businessObjectDefinitionColumn';
import { BusinessObjectDefinitionColumnCreateRequest } from '../model/businessObjectDefinitionColumnCreateRequest';
import { BusinessObjectDefinitionColumnKeys } from '../model/businessObjectDefinitionColumnKeys';
import { BusinessObjectDefinitionColumnSearchRequest } from '../model/businessObjectDefinitionColumnSearchRequest';
import { BusinessObjectDefinitionColumnSearchResponse } from '../model/businessObjectDefinitionColumnSearchResponse';
import { BusinessObjectDefinitionColumnUpdateRequest } from '../model/businessObjectDefinitionColumnUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectDefinitionColumnService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createBusinessObjectDefinitionColumn
     * Creates a new business object definition column. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param businessObjectDefinitionColumnCreateRequest the information needed to create a business object definition column
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionColumnCreateBusinessObjectDefinitionColumn(businessObjectDefinitionColumnCreateRequest: BusinessObjectDefinitionColumnCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionColumn>;
    public businessObjectDefinitionColumnCreateBusinessObjectDefinitionColumn(businessObjectDefinitionColumnCreateRequest: BusinessObjectDefinitionColumnCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnCreateBusinessObjectDefinitionColumn(businessObjectDefinitionColumnCreateRequest: BusinessObjectDefinitionColumnCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnCreateBusinessObjectDefinitionColumn(businessObjectDefinitionColumnCreateRequest: BusinessObjectDefinitionColumnCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionColumnCreateRequest === null || businessObjectDefinitionColumnCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionColumnCreateRequest was null or undefined when calling businessObjectDefinitionColumnCreateBusinessObjectDefinitionColumn.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionColumn>(`${this.configuration.basePath}/businessObjectDefinitionColumns`,
            businessObjectDefinitionColumnCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDefinitionColumn
     * Deletes an existing column for the business object definition. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param businessObjectDefinitionColumnName the name of the business object definition column
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionColumn>;
    public businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionColumnName === null || businessObjectDefinitionColumnName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionColumnName was null or undefined when calling businessObjectDefinitionColumnDeleteBusinessObjectDefinitionColumn.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDefinitionColumn>(`${this.configuration.basePath}/businessObjectDefinitionColumns/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectDefinitionColumnNames/${encodeURIComponent(String(businessObjectDefinitionColumnName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionColumn
     * Gets an existing column for the business object definition.
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param businessObjectDefinitionColumnName the name of the business object definition column
     * @param includeBusinessObjectDefinitionColumnUpdateHistory the boolean flag to determine whether or not to include business object definition column update history in the get results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, includeBusinessObjectDefinitionColumnUpdateHistory?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionColumn>;
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, includeBusinessObjectDefinitionColumnUpdateHistory?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, includeBusinessObjectDefinitionColumnUpdateHistory?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, includeBusinessObjectDefinitionColumnUpdateHistory?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionColumnName === null || businessObjectDefinitionColumnName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionColumnName was null or undefined when calling businessObjectDefinitionColumnGetBusinessObjectDefinitionColumn.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeBusinessObjectDefinitionColumnUpdateHistory !== undefined && includeBusinessObjectDefinitionColumnUpdateHistory !== null) {
            queryParameters = queryParameters.set('includeBusinessObjectDefinitionColumnUpdateHistory', <any>includeBusinessObjectDefinitionColumnUpdateHistory);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionColumn>(`${this.configuration.basePath}/businessObjectDefinitionColumns/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectDefinitionColumnNames/${encodeURIComponent(String(businessObjectDefinitionColumnName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionColumns
     * Gets a list of keys for all existing business object definition columns for a specific business object definition.
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumns(namespace: string, businessObjectDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionColumnKeys>;
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumns(namespace: string, businessObjectDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionColumnKeys>>;
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumns(namespace: string, businessObjectDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionColumnKeys>>;
    public businessObjectDefinitionColumnGetBusinessObjectDefinitionColumns(namespace: string, businessObjectDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionColumnGetBusinessObjectDefinitionColumns.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionColumnGetBusinessObjectDefinitionColumns.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionColumnKeys>(`${this.configuration.basePath}/businessObjectDefinitionColumns/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchBusinessObjectDefinitionColumns
     * Retrieve a list of business object definition columns meeting the search criteria filters and fields request.
     * @param businessObjectDefinitionColumnSearchRequest the search criteria needed to find a list of business object definition columns
     * @param fields the field options for the business object definition columns search response. The valid field options are: description, schemaColumnName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionColumnSearchBusinessObjectDefinitionColumns(businessObjectDefinitionColumnSearchRequest: BusinessObjectDefinitionColumnSearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionColumnSearchResponse>;
    public businessObjectDefinitionColumnSearchBusinessObjectDefinitionColumns(businessObjectDefinitionColumnSearchRequest: BusinessObjectDefinitionColumnSearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionColumnSearchResponse>>;
    public businessObjectDefinitionColumnSearchBusinessObjectDefinitionColumns(businessObjectDefinitionColumnSearchRequest: BusinessObjectDefinitionColumnSearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionColumnSearchResponse>>;
    public businessObjectDefinitionColumnSearchBusinessObjectDefinitionColumns(businessObjectDefinitionColumnSearchRequest: BusinessObjectDefinitionColumnSearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionColumnSearchRequest === null || businessObjectDefinitionColumnSearchRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionColumnSearchRequest was null or undefined when calling businessObjectDefinitionColumnSearchBusinessObjectDefinitionColumns.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionColumnSearchResponse>(`${this.configuration.basePath}/businessObjectDefinitionColumns/search`,
            businessObjectDefinitionColumnSearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDefinitionColumn
     * Updates an existing column for the business object definition. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param businessObjectDefinitionColumnName the name of the business object definition column
     * @param businessObjectDefinitionColumnUpdateRequest the request information needed to update the business object definition column
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, businessObjectDefinitionColumnUpdateRequest: BusinessObjectDefinitionColumnUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionColumn>;
    public businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, businessObjectDefinitionColumnUpdateRequest: BusinessObjectDefinitionColumnUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, businessObjectDefinitionColumnUpdateRequest: BusinessObjectDefinitionColumnUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionColumn>>;
    public businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionColumnName: string, businessObjectDefinitionColumnUpdateRequest: BusinessObjectDefinitionColumnUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionColumnName === null || businessObjectDefinitionColumnName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionColumnName was null or undefined when calling businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn.');
        }
        if (businessObjectDefinitionColumnUpdateRequest === null || businessObjectDefinitionColumnUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionColumnUpdateRequest was null or undefined when calling businessObjectDefinitionColumnUpdateBusinessObjectDefinitionColumn.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDefinitionColumn>(`${this.configuration.basePath}/businessObjectDefinitionColumns/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectDefinitionColumnNames/${encodeURIComponent(String(businessObjectDefinitionColumnName))}`,
            businessObjectDefinitionColumnUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
